/**
 * proposalsAccess — the pure access rule for the Proposals feature (EPIC-PROP-001).
 *
 * v1 rollout gate: Proposals is visible ONLY in Tripper's Sandbox while the feature is built out.
 * This is a deliberate tenant allowlist, NOT a permission model — it will be swapped for a
 * `tenant_settings` flag / role gate (mirroring the Contracts feature access) at GA. Kept pure +
 * dependency-free so it is trivially unit-testable and reused by the hook + any entry-point guard.
 */

/** Tenants where Proposals is enabled during the gated rollout. */
export const PROPOSALS_ENABLED_TENANT_IDS: ReadonlySet<string> = new Set([
  '08058ed4-ddd1-48d6-8a8c-b236bbc04372', // Tripper's Sandbox
]);

/** True when Proposals should be visible for the given tenant. */
export function isProposalsEnabledForTenant(tenantId: string | null | undefined): boolean {
  return !!tenantId && PROPOSALS_ENABLED_TENANT_IDS.has(tenantId);
}
